import React, { useEffect, useState } from "react"
import { FastField, useFormikContext, values } from "formik"
import { useQuery } from "react-query"
import FormError from "../../../formError"

const order_number =
  typeof window !== `undefined` ? localStorage.getItem("orderReference") : null
const dd_token =
  typeof window !== `undefined`
    ? localStorage.getItem("6d361f1d1c1160c1f")
    : null

const BusinessInfo = () => {
  const { errors, touched, values, setFieldValue } = useFormikContext()
  const [businessInfo, setBusinessInfo] = useState([])
  const [businessNature, setBusinessNature] = useState([])

  const getBusinessNature = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/BusinessNatures`)
      .then((response) => response.json())
      .then((data) => {
        setBusinessNature(data)
      })
  }

  const getCurrentData = () => {
    fetch(
      `${process.env.DIY_BASE_URL}/api//order/v1/BusinessName/step1?order-ref=${order_number}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${dd_token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setBusinessInfo(data)
      })
  }

  const {
    isLoading,
    error,
    data: countries,
    isFetching,
  } = useQuery("countries", () =>
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/Countries`).then((res) =>
      res.json()
    )
  )

  const {
    isLoading: statesLoading,
    error: stateError,
    data: st,
    isFetching: isFetchingStates,
  } = useQuery("st", () =>
    fetch(`${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/kyc/states`).then((res) =>
      res.json()
    )
  )

  useEffect(() => {
    getBusinessNature()
    getCurrentData()
  }, [])

  if (isFetchingStates) return "Loading..."
  if (error) return "An error has occurred: " + error.message

  return (
    <>
      <div className="form-row justify-between">
        <div className="form-group col-md-5 ">
          <label htmlFor="business_name1"> Business Name Sample 1</label>
          <FastField
            type="text"
            className="form-control"
            id="business_name1"
            name="business_name1"
            defaultValue={businessInfo.business_name1}
          />

          <FormError
            touched={touched.business_name1}
            message={errors.business_name1}
          />
        </div>

        <div className="form-group col-md-5 ">
          <label htmlFor="business_name2"> Business Name Sample 2</label>
          <FastField
            type="text"
            className="form-control"
            id="business_name2"
            name="business_name2"
            defaultValue={businessInfo.business_name2}
          />

          <FormError
            touched={touched.business_name2}
            message={errors.business_name2}
          />
        </div>
      </div>
      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="business_name3"> Business Name Sample 3</label>
          <FastField
            type="text"
            className="form-control"
            id="business_name3"
            name="business_name3"
            defaultValue={businessInfo.business_name3}
          />

          <FormError
            touched={touched.business_name3}
            message={errors.business_name3}
          />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="business_name4"> Business Name Sample 4</label>
          <FastField
            type="text"
            className="form-control"
            id="business_name4"
            name="business_name4"
            defaultValue={businessInfo.business_name4}
          />

          <FormError
            touched={touched.business_name4}
            message={errors.business_name4}
          />
        </div>
      </div>

      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="business_nature">Purpose of the business</label>

          <FastField
            className="form-control custom-select mb-4"
            as="select"
            id="business_nature"
            name="business_nature"
          >
            <option value="">Select Business Nature</option>
            {businessNature.map((data, index) => (
              <option key={index} value={data.value}>
                {data.display}
              </option>
            ))}
          </FastField>

          <FormError
            touched={touched.business_nature}
            message={errors.business_nature}
          />
        </div>

        <div className="form-group col-md-5">
          {values.business_nature === "Others" && (
            <>
              <label htmlFor="other_business_nature">
                Other business nature
              </label>

              <FastField
                type="text"
                className="form-control"
                id="other_business_nature"
                name="other_business_nature"
                defaultValue={businessInfo.other_business_nature}
              />
            </>
          )}
        </div>
      </div>

      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="country">Country</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="country"
            name="country"
          >
            <option value="">Select Country</option>
            {countries?.map((country) => (
              <option key={country.value} value={country.value}>
                {country.display}
              </option>
            ))}
          </FastField>

          <FormError touched={touched.country} message={errors.country} />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="state">State</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="state"
            name="state"
          >
            <option value="" label="Select State">
              Select State
            </option>
            {st?.data.map((data) => (
              <option key={data.id} value={data.name}>
                {data.name}
              </option>
            ))}
          </FastField>

          <FormError touched={touched.state} message={errors.state} />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group col-md-5">
          <label htmlFor="city">City</label>
          <FastField
            type="text"
            className="form-control"
            id="city"
            name="city"
          />

          <FormError touched={touched.city} message={errors.city} />
        </div>
      </div>

      <div className="form-row ">
        <div className="form-group col-md-12">
          <label htmlFor="type_of_business">Business address</label>
          <FastField
            className="form-control"
            id="address"
            name="address"
            as="textarea"
            rows="3"
          />

          <FormError touched={touched.address} message={errors.address} />
        </div>
      </div>
    </>
  )
}
export default BusinessInfo
